import React from 'react'
import { Link } from 'react-router-dom'
import managementService from '../../services/managementService'
import ManagementReportShell from './ManagementReportShell'
import useManagementReport from './useManagementReport'
import { HealthBadge, KpiGrid, KpiTile, Section, Unavailable } from './ManagementWidgets'
import { SIGNAL_ROUTES, exportToSpreadsheet, flattenMetrics, groupKpis, kpiMeta, metricText } from './managementUtils'

export const HealthSignals = ({ signals }) => {
  if (!Array.isArray(signals) || !signals.length) return <Unavailable>No health signals available</Unavailable>
  return (
    <div className="mis-kpi-grid">
      {signals.map((s) => {
        const to = SIGNAL_ROUTES[s.key]
        const inner = (
          <>
            <div className="mis-kpi-label">{s.label}</div>
            <div style={{ marginTop: 6 }}><HealthBadge status={s.status} label={s.status === 'Grey' ? 'No data' : s.status} /></div>
          </>
        )
        const cls = `mis-kpi mis-kpi-${String(s.status || 'grey').toLowerCase()}`
        return to
          ? <Link key={s.key} to={to} className={`${cls} mis-kpi-link`}>{inner}</Link>
          : <div key={s.key} className={cls}>{inner}</div>
      })}
    </div>
  )
}

export const KpiGroups = ({ kpis }) => {
  const groups = groupKpis(kpis)
  if (!groups.length) return <Unavailable />
  return groups.map(({ group, items }) => (
    <Section key={group} title={group}>
      <KpiGrid>
        {items.map(({ key, metric, meta }) => (
          <KpiTile key={key} label={meta.label} metric={metric} format={meta.format} to={meta.to} />
        ))}
      </KpiGrid>
    </Section>
  ))
}

const MisSnapshotReport = () => {
  const report = useManagementReport(managementService.getSnapshot)

  const onExport = (data) => exportToSpreadsheet('mis-snapshot', {
    KPIs: Object.entries(data.kpis || {}).map(([k, m]) => ({
      KPI: kpiMeta(k).label,
      Value: metricText(m, kpiMeta(k).format),
      Status: m?.status || 'missing',
      Note: m?.note || ''
    })),
    'Health signals': (data.healthSignals || []).map((s) => ({ Signal: s.label, Status: s.status })),
    'All metrics': flattenMetrics(data)
  })

  return (
    <ManagementReportShell
      title="MIS Snapshot"
      subtitle="Company health at a glance — every tile drills into its detailed report"
      report={report}
      onExport={onExport}
      overallHealth={report.data?.overallHealth}
    >
      {(data) => (
        <>
          <Section title="Health signals" subtitle="Grey means the source data is not configured or not recorded yet">
            <HealthSignals signals={data.healthSignals} />
          </Section>
          <KpiGroups kpis={data.kpis} />
        </>
      )}
    </ManagementReportShell>
  )
}

export default MisSnapshotReport
